import React from "react";
import { Link, useParams } from "react-router-dom";
import {
  BookOpen,
  ChevronRight,
  CircleHelp,
  LifeBuoy,
  Megaphone,
  Rocket,
  Video,
  Wrench,
} from "lucide-react";
import { getHelpSectionBySlug } from "./helpCenterContent";

const SECTION_ICONS = {
  helpCircle: CircleHelp,
  rocket: Rocket,
  bookOpen: BookOpen,
  video: Video,
  wrench: Wrench,
  megaphone: Megaphone,
  lifeBuoy: LifeBuoy,
};

export default function HelpSectionPage() {
  const { sectionSlug } = useParams();
  const section = getHelpSectionBySlug(sectionSlug);

  if (!section) {
    return (
      <div className="help-section-not-found">
        <h1>Section not found</h1>
        <p>That help topic does not exist or may have moved.</p>
        <Link to="/help">Back to Help Center</Link>
      </div>
    );
  }

  const Icon = SECTION_ICONS[section.icon] || CircleHelp;

  return (
    <>
      <nav className="help-section-breadcrumb" aria-label="Breadcrumb">
        <Link to="/help">Help Center</Link>
        <span aria-hidden="true">
          <ChevronRight size={14} />
        </span>
        <span aria-current="page">{section.title}</span>
      </nav>

      <header className="help-section-header">
        <span className="help-section-header-icon" aria-hidden="true">
          <Icon size={24} strokeWidth={2} />
        </span>
        <h1>{section.title}</h1>
        <p>{section.description}</p>
      </header>

      <section className="help-section-articles">
        <h2>Popular articles</h2>
        <ul className="help-section-article-list">
          {section.articles.map((title) => (
            <li key={title}>
              <button type="button" disabled aria-disabled="true">
                <span className="article-title">{title}</span>
                <span className="article-meta">Coming soon</span>
              </button>
            </li>
          ))}
        </ul>
        <p className="help-section-note">
          Full article content will replace these placeholders. Use this section
          template as the shell for real documentation later.
        </p>
      </section>
    </>
  );
}
